export const EVENTS = Object.freeze({
  ANY: 'any',
  interceptPayment: 'interceptPayment',
  interceptConfirm: 'interceptConfirm',
  interceptAbort: 'interceptAbort',
  paymentSuccessful: 'paymentSuccessful',
  paymentFailed: 'paymentFailed',
  paymentRedirect: 'paymentRedirect',
  initConfirm: 'initConfirm',
  loginSuccessful: 'loginSuccessful',
  loginFailed: 'loginFailed',
  loginCancelled: 'loginCancelled',
  lockUi: 'lockUi',
  unlockUi: 'unlockUi'
});
